export default __webpack_public_path__ + "static/media/banner-image.412a2f65.png";